import { render, staticRenderFns } from "./retrieveEmail.vue?vue&type=template&id=8c1d1364&scoped=true&"
import script from "./retrieveEmail.vue?vue&type=script&lang=js&"
export * from "./retrieveEmail.vue?vue&type=script&lang=js&"
import style0 from "./retrieveEmail.vue?vue&type=style&index=0&id=8c1d1364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1d1364",
  null
  
)

export default component.exports